module.exports = __webpack_public_path__ + "media/images/linkedin-73b0305dfc5c45b8c95c66d02c4a4b81.svg";